type ApiPost = (
    url: string,
    payload: object,
    errorMessage: string
) => Promise<{ data?: unknown }>;

export const makeSrAgentPosts = (api: ApiPost) => ({
    postChat: async (payload: Record<string, unknown>) => {
        const response = await api(
            "unified_service_request/sr-agent/chat",
            payload,
            "SR agent failed"
        );
        return (response as { data?: unknown })?.data;
    },
    postTranscribe: async (payload: Record<string, unknown>) => {
        const response = await api(
            "unified_service_request/sr-agent/transcribe",
            payload,
            "SR voice transcribe failed"
        );
        return (response as { data?: unknown })?.data;
    },
});
